var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "d-inline",
    class: (_class = {}, _class['font-weight-bold'] = _vm.lecture.code.isOn, _class),
    attrs: {
      "x-small": "",
      "text": ""
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm.lecture.code.isOn ? [_vm._v(" 참여코드 : " + _vm._s(_vm.lecture.code.text) + " ")] : [_vm._v(" 누구나 참여 가능 ")]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }